import { styled } from '@mui/system';
import { Box, Typography, Button } from '@mui/material';

export const ShiftContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  width: '100%',
  padding: '10px 10px',
  boxSizing: 'border-box',
  gap: '10px',
});

export const LeftBox = styled(Box)({
  flexBasis: '60%',
  flexGrow: 1,
  maxWidth: '60%',
  backgroundColor: '#000000',
  borderRadius: '16px',
  padding: '30px 25px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  height: '88vh',
  overflow: 'hidden',
});

export const RightBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isDetailsView',
})(({ isDetailsView }) => ({
  flexBasis: '40%',
  flexGrow: 1,
  maxWidth: '40%',
  background: isDetailsView
    ? '#000000' // Black background for shift details view
    : 'radial-gradient(circle at top left, rgba(27, 0, 166, 0.2), black)', // Gradient for default view
  borderRadius: '16px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  height: '88vh',
  overflow: 'hidden'
}));

export const ScrollableContent = styled(Box)({
  overflowY: 'auto',
  overflowX: 'hidden',
  width: '100%',
  height: '100%',
  paddingRight: "10px",
  boxSizing: 'border-box',
});

export const WeekTitle = styled(Typography)({
  marginBottom: '20px',
  color: 'white',
});

export const CircleLogo = styled('img')({
  height: '200px',
  zIndex: 1,
});

export const StyledButton = styled(Button)({
  width: '100%',
  maxWidth: '450px',
});

export const WeeklyShiftsContainer = styled(Box)({
  width: '100%',
  backgroundColor: '#7676803D',
  borderRadius: '10px'
});
